import { Project } from "interfaces";

import Tag from "ui-components/Tag";
import FilterSummary from "ui-components/Data-Filters/Filter-Summary";

import * as flowConfig from "flows/sales-effectiveness/config";

import { projectIsSalesEffectiveness } from "flows/sales-effectiveness/interfaces";

const ContextSummary = ({
  project,
  hideModelTag,
}: {
  project: Project;
  hideModelTag?: boolean;
}) => {
  if (!projectIsSalesEffectiveness(project)) {
    return null;
  }

  const modelsBuilt = project.workspaces.length >= 1;

  const successDef = project.meta_data[flowConfig.SUCCESS_DEFINITION_KEY];

  return (
    <div className="m-1">
      {successDef.length === 1 ? (
        <>
          <p>
            <span className="italic underline">Sales Success</span> defined as{" "}
            <FilterSummary filter={successDef[0]} skipCondition />
          </p>
        </>
      ) : (
        <>
          <p>
            <span className="italic underline">Sales Success</span> defined as
            satisfying ALL THE BELOW FILTERS:
          </p>
          <ul className="ml-2 pl-2 list-decimal list-inside">
            {successDef.map((f, ind) => (
              <li key={ind}>
                <FilterSummary filter={f} />
              </li>
            ))}
          </ul>
        </>
      )}
      {!hideModelTag && modelsBuilt && (
        <div className="flex flex-wrap">
          <Tag bgColorClass="bg-primary-main" textColorClass="text-gray-100">
            Model Built
          </Tag>
        </div>
      )}
    </div>
  );
};

export default ContextSummary;
